import React from 'react';
import { Link } from 'react-router';
import '../stylesheets/core.less';

function NotFound() {
  return (
    <div className="not-found">
      <header className="minimal-header">
        <div className="zola-weddings-logo-black-120 center-block" />
      </header>
      <div className="container text-center">
        <h1>Uh-oh!</h1>
        <p>
          Well this is a bummer. It seems the page you&#39;re looking for doesn&#39;t exist.
        </p>
        <p className="margin-top">
          <Link className="btn btn-primary btn-wide margin-right" to="/wedding">Go To Zola</Link>
          <a className="btn btn-secondary btn-wide" href="/search/wedding-registry">Find a Couple</a>
        </p>
        <img className="img-responsive center-block not-found-gif" src="https://s3.amazonaws.com/zola-web-assets/web-wedding/404-cake.gif" alt="404 Page Not Found" />
      </div>
      <footer className="zola-footer footer-minimal" id="zola-footer">
        <small className="text-muted">
          &copy; 2018 Zola, Inc. All rights reserved. <a href="/privacy" target="_blank" rel="noopener noreferrer" >Privacy Policy</a> / <a href="/terms" target="_blank" rel="noopener noreferrer">Terms of Use</a>
        </small>
      </footer>
    </div>
  );
}

export default NotFound;



/** WEBPACK FOOTER **
 ** ./src/pages/NotFound.jsx
 **/